module.exports = __webpack_public_path__ + "static/homepage_hero4-283cf7b93d26600b3d843b18f846501a.jpg";